module.exports = require('react-dom/lib/ReactPerf');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-perf/index.js
// module id = 1746
// module chunks = 2